export enum MessageType {
  TEXT = "text",
  BUTTON = "button",
  CAROUSEL = "carousel",
  QUICK_RREPLY = "quick-reply",
  INFO = "info",
}

export enum ConversationInboxEnum {
  ALL = "all",
  UNREAD = "unread",
  ASSIGNED_TO_YOU = "you",
  UNASSIGNED = "unassigned",
  RESOLVED = "resolved",
}

export enum UserConversationRoleEnum {
  CUSTOMER = "customer",
  BOT = "bot",
  LIVE_CHAT_AGENT = "live_chat_agent",
  SYSTEM = "system",
  PENDING = "pending",
}

export enum SortEnum {
  ASC = "asc",
  DESC = "desc",
}

export enum ConversationStatusFilter {
  ACTIVE = "active",
  RESOLVED = "resolved",
  INACTIVE = "inactive",
}

export enum ChannelListEnum {
  ALL = "ALL",
  WEB = "web",
  WHATSAPP = "whatsapp",
  FACEBOOK = "facebook",
  INSTAGRAM = "instagram",
  // LINE = "line",
  // KAKAOTALK = "kakaotalk",
}

export enum StatusFilterEnum {
  ALL = "all",
}

export enum KnowledgeBaseStatusEnum {
  INDEXED = "indexed",
  PROCESSING = "processing",
  STARTED = "started",
  COMPLETED = "completed",
  FAILED = "failed",
  PENDING = "pending",
}

export enum KnowledgeQueryTypeEnum {
  UNRESOLVED = "unresolved",
  RESOLVED = "resolved",
  KNOWLEDGE_ADDED = "knowledge_added",
  ARCHIVED = "archived",
}

export enum ObjectFileTypeEnum {
  FLOWS = "flows",
  IMPORT_QUESTION_ANSWER = "import_question_answer",
  IMPORT_DOCUMENT = "knowledgebase_documents",
  CHANNEL_AVATAR = "channel_avatar",
  ORGANIZATION_LOGO = "organization_logo",
  PROJECT_LOGO = "project_logo",
  PRODUCT_CATALOGUE = "product_catalogue",
  BROADCAST = "broadcast",
  SNIPPET = "snippet",
  OTHERS = "others",
  WIDGET = "widget",
  FB_OPT_IN = "fb_optin",
}

export const KnowledgeBasePositiveStatuses = [
  KnowledgeBaseStatusEnum.COMPLETED,
  KnowledgeBaseStatusEnum.INDEXED,
  KnowledgeBaseStatusEnum.FAILED,
];

export enum DomainStatusEnum {
  ACTIVE = "active",
  PENDING = "pending",
  INACTIVE = "inactive",
}

export enum FocusWidgetElementEnum {
  header = "header",
  welcomeMessage = "welcomeMessage",
  headerSubtitle = "headerSubtitle",
  placeholderMessage = "placeholderMessage",
  Starters = "Starters",
}

export enum WidgetThemeType {
  basic = "basic",
  sleek = "sleek",
}

export enum InvitationStatusEnum {
  PENDING = "pending",
  ACCEPTED = "accepted",
  DECLINED = "declined",
}

export enum TeamMemberStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  BANNED = "banned",
}

export enum FlowStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum MediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  YOUTUBE_VIDEO = "YOUTUBE_VIDEO",
  GIF = "GIF",
  UNKNOWN = "UNKNOWN",
}

export enum VoteTypeEnum {
  unlikely = "unlikely",
  likely = "likely",
}

export enum CustomerSurveyPhaseEnum {
  csat = "csat",
  nps = "nps",
  additional = "additional",
  finish = "finish",
  default = "default",
}

export enum ProjectStatusEnum {
  Active = "active",
  Inactive = "inactive",
}

export enum ToneListEnum {
  friendly = "Friendly",
  formal = "professional",
  concise = "Efficient",
  warm = "Warm",
}

export enum DomainStrictListEnum {
  flexible = "Flexible",
  moderate = "Moderate",
  strict = "Strict",
}

export enum ResponseListEnum {
  short = "Short",
  medium = "Medium",
  long = "Long",
}

export enum TierEnum {
  free = "free",
  starter = "starter",
  pro = "pro",
}

export enum FlagsmithFlags {
  PAYMENT_TRIAL_TYPE = "payment_trial_type",
  WHATSAPP = "enable_whatsapp",
  FACEBOOK = "enable_facebook",
  INSTAGRAM = "enable_instagram",
  DRIP_CAMPAIGN = "enable_drip_campaign",
  HUB_SPOT = "enable_hubspot",
  AGENT_INACTIVITY_TIME = "agent_inactivity_timeout_minutes",
}

export enum FlagsmithTraits {
  DIGITAL_HUMAN = "digital_human",
  ENABLE_AKOOL = "enable_akool",
  AKOOL_AVATAR_ID = "akool_avatar_id",
  AKOOL_VOICE_ID = "akool_voice_id",
  HEYGEN_AVATAR_NAME = "heygen_avatar_name",
  HEYGEN_VOICE_ID = "heygen_voice_id",
  HEYGEN_AVATAR_SLUG = "heygen_avatar_slug",
  VOICE_MODE = "voice_mode",
  WHATSAPP = "enable_whatsapp",
  ENABLE_OPENAI_TRANSCRIPTION = "enable_openai_transcription",
}

export enum NotificationFieldEnum {
  PRODUCT_CATALOGUE = "product_catalogue",
}
export enum NotificationTypeEnum {
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
}

export enum BroadcastStatusEnum {
  DRAFT = "draft",
  SCHEDULED = "scheduled",
  SENDING = "sending",
  COMPLETED = "completed",
  FAILED = "failed",
  CANCELED = "canceled",
  PAUSED = "paused",
}

export enum CampaignStatusEnum {
  DRAFT = "draft",
  PUBLISH = "publish",
  PAUSED = "paused",
}

export enum CampaignEventTypeEnum {
  SUBMITTED_FORM = "submitted_form",
  CLICKED_BUTTON = "clicked_button",
  CLICKED_BUTTON_PREVIOUS_MESSAGE = "clicked_button_previous_message",
  NOT_RESPOND_PREVIOUS_MESSAGE = "not_respond_previous_message",
  RESPOND_PREVIOUS_MESSSAGE = "respond_previous_messsage",
  TRIGGERED_FLOW = "triggered_flow",
  CLICKED_BUTTON_IN_FLOW = "clicked_button_in_flow",
  BROADCAST_SENT = "broadcast_sent",
  INACTIVE_PERIOD = "inactive_period",
  ATTRIBUTE_UPDATED = "attribute_updated",
  ATTRIBUTE = "attribute",
  TAG_ADDED = "tag_added",
  TAG = "tag",
  PROFILE_CREATED = "profile_created",
  LIVE_CHAT = "live_chat",
  WEBHOOK_RECEIVED = "webhook_received",
  LAST_SEEN = "last_seen",
  REPLIED_WITH_KEYWORD = "replied_with_keyword",
  RESPOND_ANY_MESSAGE = "respond_any_message",
  HUBSPOT_NEW_CONTACT_IMPORTED = "hubspot_new_contact_imported",
  HUBSPOT_EXISTING_CONTACT_UPDATED = "hubspot_existing_contact_updated",
}

export enum SystemEventsStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum QuotaKeyEnum {
  AICHAT_CREDIT = "aiChatCredit",
  MAX_USERS = "maxUsers",
  WEBSITE_QUOTA = "websiteQuota",
  TEXT_SNIPPET_QUOTA = "textSnippetQuota",
  DOCUMENT_QUOTA = "documentQuota",
  PRODUCT_CATALOGUE_ITEMS_QUOTA = "productCatalogueItemsQuota",
  FLOW_QUOTA = "flowQuota",
  MAX_PROJECTS = "maxProjects",
}

export enum PlansEnum {
  FREE = "FREE_PLAN",
  ENTERPRISE = "ENTERPRISE_PLAN",
  TEAM = "Team",
  SOLO = "Solo",
}

export enum WhatsappTemplateStatusEnum {
  DRAFT = "DRAFT",
  APPROVED = "APPROVED",
  DISABLED = "DISABLED",
  IN_APPEAL = "IN_APPEAL",
  PENDING = "PENDING",
  REINSTATED = "REINSTATED",
  REJECTED = "REJECTED",
  FLAGGED = "FLAGGED",
  PAUSED = "PAUSED",
  PENDING_DELETION = "PENDING_DELETION",
}
export enum HttpMethodEnum {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum CommentAutomationStatusEnum {
  ACTIVE = "active",
  INACTIVE = "inactive",
  DRAFT = "draft",
  SCHEDULED = "scheduled",
}

export enum CommentAutomationPostStatusEnum {
  SCHEDULED = "scheduled",
  PUBLISHED = "published",
  UNPUBLISHED = "unpublished",
  PROMOTED = "promoted",
}
